import { CSS } from '@grupoboticario/flora-react'

export const containerCss: CSS = {
  flex: '1 1 0',
  fontWeight: '500',
  minWidth: 'max-content'
}

export const tagCss = (
  color: string,
  backgroundColor: string,
  textTransform: 'capitalize' | 'none' = 'capitalize'
): CSS => ({
  alignSelf: 'flex-start',
  backgroundColor,
  borderRadius: '$large',
  color,
  fontSize: '$md',
  textTransform,
  width: 'fit-content'
})

export const emphasisTextCss: CSS = {
  color: '$linkDefault',
  whiteSpace: 'nowrap'
}

export const valueCss: CSS = {
  whiteSpace: 'nowrap'
}
